import useSEO from "../hooks/useSEO";
import PageHero from "../components/PageHero";

export default function LegalPage({ seo, eyebrow, title, updated, intro, sections, testId }) {
  useSEO(seo);
  return (
    <>
      <PageHero eyebrow={eyebrow} title={title} subtitle={`Last updated: ${updated}`} />
      <section className="bg-white py-16 md:py-24" data-testid={testId}>
        <div className="container-x max-w-3xl">
          <p className="text-base leading-relaxed text-slate-600 md:text-lg">{intro}</p>
          {sections.map((s, i) => (
            <div key={i} className="mt-12">
              <h2 className="font-display text-2xl font-medium tracking-tight text-[#07111F]">
                {i + 1}. {s.title}
              </h2>
              {s.paragraphs?.map((p, j) => (
                <p key={j} className="mt-4 text-base leading-relaxed text-slate-600">{p}</p>
              ))}
              {s.items && (
                <ul className="mt-4 space-y-3">
                  {s.items.map((item, j) => (
                    <li key={j} className="flex gap-3 text-base leading-relaxed text-slate-600">
                      <span className="mt-[0.6rem] h-1.5 w-1.5 shrink-0 rounded-full bg-blue-600" />
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
          <div className="mt-14 rounded-2xl border border-slate-200 bg-[#F8FAFC] p-6 text-sm leading-relaxed text-slate-500">
            Questions about this document? Contact us at{" "}
            <a href="mailto:contact@sefkam.com" className="font-medium text-[#07111F] underline underline-offset-2" data-testid="legal-contact-email">
              contact@sefkam.com
            </a>.
          </div>
        </div>
      </section>
    </>
  );
}
